/**
 * Every page follows the device's light/dark setting, like the app: light
 * only when the device asks for it, dark otherwise (also with no preference,
 * the app's default). The CSS does the same (tailwind.theme.js); this is for
 * what CSS can't reach, such as Stripe's card form (an iframe).
 */
export type ColorScheme = "dark" | "light"

export const LIGHT_MEDIA_QUERY = "(prefers-color-scheme: light)"

type MatchMedia = (query: string) => { matches: boolean }

export function colorSchemeFor(
  matchMedia: MatchMedia | undefined = typeof window === "undefined"
    ? undefined
    : window.matchMedia?.bind(window),
): ColorScheme {
  return matchMedia?.(LIGHT_MEDIA_QUERY).matches ? "light" : "dark"
}
